/* global Sys, Core */
Sys.ns("Core.Slots");

/**
 * The bonus program widget module.
 *
 * @class Core.Slots.BonusProgramWidget
 * @extends Core.Module
 */
Core.Slots.BonusProgramWidget = {
    constructor: function() {
        Core.Slots.BonusProgramWidget.superclass.constructor.apply(this, arguments);
    },

    /**
     * @protected
     * @inheritdoc
     */
    getMixinDependencies: function() {
        return ["orientation"];
    },

    /**
     * @protected
     * @inheritdoc
     */
    getDefaultMVCClasses: function() {
        return {
            model: Core.Slots.BonusProgramWidgetModel,
            controller: Core.Slots.BonusProgramWidgetController,
            view: Core.Slots.BonusProgramWidgetView
        };
    },

    /**
     * @protected
     * @inheritdoc
     */
    getStateChanges: function() {
        var model = this.model,
            widgetUrl = model.readData("widgetUrl"),
            nextAction = model.readData("nextAction");

        return {
            beforeLoaderClose: {
                queue: [
                    function(env) {
                        if (model.bonusProgramWidgetEnabled() && widgetUrl && nextAction === "spin") {
                            env.stateHandler.pushState(env.states.bonusProgramWidget);
                        }
                    }
                ]
            },
            checkForAdditionalFreeRounds: {
                waitEvents: [
                    "notify:bonusProgramWidget.closed"
                ]
            },
            bonusProgramWidget: {
                state: {
                    name: "BonusProgramWidget",
                    execute: function() {
                        // stub
                    },
                    waitEvents: {
                        "notify:bonusProgramWidget.closed": false,
                        "notify:responseParser.gameConfigurationParsed": false
                    }
                }
            }
        };
    }
};

Core.Slots.BonusProgramWidget = Sys.extend(Core.Module, Core.Slots.BonusProgramWidget, "Core.Slots.BonusProgramWidget");
